"use client";
import { useEffect } from "react";

export default function ShowGoToTop() {
    useEffect(() => {
        window.addEventListener('scroll', function () {
            const position = window.pageYOffset;
            var element = document.getElementsByClassName("scroll-to-target");
            if (position > 100) element[0]?.classList.remove('d-none');
            if (position < 100) element[0]?.classList.add('d-none');
        });
    }, []);
    return true;
};

export const goToTop = () => {
    window.scrollTo({
        top: 0,
        behavior: "smooth",
    });
};